import { SvgIcon } from '@mui/material';
import './ccf-hours-of-operation-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfHoursOfOperationIconProps  {}

/**
 *
 * @param props - CcfHoursOfOperationIcon
 * @example <CcfHoursOfOperationIcon />
 * @returns
 */
export function CcfHoursOfOperationIcon(props: CcfHoursOfOperationIconProps) {
  return (
    <SvgIcon
      // width="20"
      // height="20"
      // viewBox="0 0 20 20"
      // fill="none"
      {...props}
    >
      <path
        d="M10 10V6.65C10 6.0975 9.5525 5.65 9 5.65C8.4475 5.65 8 6.0975 8 6.65V11.31C8 11.78 8.78 12 9.25 12H15.25C15.8025 12 16.25 11.5525 16.25 11C16.25 10.4475 15.8025 10 15.25 10H10Z"
        fill="#FF9400"
      />
      <path
        d="M10 0C4.47688 0 0 4.47688 0 10C0 15.5231 4.47688 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47688 15.5231 0 10 0ZM10 18C5.58188 18 2 14.4181 2 10C2 5.58188 5.58188 2 10 2C14.4181 2 18 5.58188 18 10C18 14.4181 14.4181 18 10 18Z"
        fill="#FF9400"
      />
    </SvgIcon>
  );
}

export default CcfHoursOfOperationIcon;
